import React from 'react';
import T from 'prop-types';
import { isEmpty, last } from 'lodash-es';

import HeatMap from '../../../../components/Chart/HeatMap';
import Container from '../../../../components/Container';

import { makeChartConfig, heatColors } from '../configs/heat-map-config';
import { makeNumbersRange } from '../utils';

const HeatMapChart = ({ data }) => {
  const { title, description, data: chartData } = data;

  if (isEmpty(chartData)) return null;

  const numbersRange = makeNumbersRange(chartData.data);

  const chartConfig = makeChartConfig({ ...chartData, numbersRange });

  return (
    <div className="heat-map">
      <Container maxWidth={1248}>
        <header className="heat-map__header">
          {title && <h5 className="heat-map__title">{title}</h5>}
          <div className="heat-map__legend">
            <div className="heat-map__legend-text">{numbersRange[0]}%</div>
            {heatColors.map((item) => (
              <div key={item} className="heat-map__legend-item" style={{ backgroundColor: item }} />
            ))}
            <div className="heat-map__legend-text">{last(numbersRange)}%</div>
          </div>
        </header>
        <div className="heat-map-content">
          <div className="heat-map-content__yaxis">
            {(chartData.y_axis_categories || []).map((item) => (
              <div key={item} className="heat-map-content__yaxis-item">
                {item}
              </div>
            ))}
          </div>
          <div className="heat-map-content__chart">
            <HeatMap chartId="heatmap-chart" config={chartConfig} />
          </div>
        </div>
        <div
          className="heat-map__description"
          dangerouslySetInnerHTML={{
            __html: description,
          }}
        />
      </Container>
    </div>
  );
};

HeatMapChart.propTypes = {
  data: T.shape({
    data: T.shape({
      data: T.array,
      x_axis_categories: T.array,
      y_axis_categories: T.array,
    }),
    title: T.string,
    description: T.string,
  }),
};

export default HeatMapChart;
